var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8713_1792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8467 30.0379C59.8467 46.5888 46.4895 60.0047 30.0106 60.0047C13.5334 60.0047 0.174805 46.5888 0.174805 30.0379C0.174805 13.4882 13.5334 0.0708008 30.0106 0.0708008C46.4892 0.0708008 59.8467 13.4882 59.8467 30.0379Z",
    fill: "#1A1918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5125 18.3773L38.2333 37.5172L26.5711 28.2902L30.5125 18.3776V18.3773ZM44.2285 41.9263L32.3523 13.2193C32.0131 12.3915 31.3353 11.9531 30.5125 11.9531C29.6881 11.9531 28.9609 12.3915 28.6218 13.2193L15.5869 44.7072H20.0459L25.2059 31.7247L40.6049 44.2198C41.224 44.7227 41.671 44.9504 42.2517 44.9504C43.4151 44.9504 44.432 44.0741 44.432 42.8101C44.432 42.6043 44.3595 42.2775 44.2285 41.9263Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8713_1792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8821,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS7);
export default __webpack_public_path__ + "static/media/s7.cd97e12cfed3af247972b4d24386a458.svg";
export { ForwardRef as ReactComponent };